import { customFetch } from '../../../shared/customFetch';
import { API_ROUTES } from '../../shared/ApiRoutes';

export const signUp = (userToCreate: string) => {
  return customFetch.post(API_ROUTES.UTILISATEUR.BASE, userToCreate);
};
